export function openAppRatingOverlay(modalPath: string): void {
  void up.layer.open({
    url: modalPath,
    layer: 'new',
    history: false,
    class: ['reminder-modal', 'reminder-modal--rating'],
    abort: 'all',
  })
}
